"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var util_1 = require("./utils/util");
var storage_1 = require("./utils/storage");
var configuration_1 = require("./configuration/configuration");
var logging_1 = require("./utils/logging");
var rest_1 = require("./sharepoint/rest/rest");
var pnplibconfig_1 = require("./configuration/pnplibconfig");
exports.util = util_1.Util;
exports.sp = new rest_1.Rest();
exports.storage = new storage_1.PnPClientStorage();
exports.config = new configuration_1.Settings();
exports.log = logging_1.Logger;
exports.setup = pnplibconfig_1.setRuntimeConfig;
__export(require("./types/index"));
var Def = {
    config: exports.config,
    log: exports.log,
    setup: exports.setup,
    sp: exports.sp,
    storage: exports.storage,
    util: exports.util,
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Def;
